import { api } from './client';
import type { AuthResponse, User } from '../../types';

export interface RegisterPayload {
  full_name: string;
  email: string;
  phone: string;
  password: string;
  referral_source?: string;
}

export interface RegisterResult {
  requires_verification: boolean;
  email: string;
  message: string;
}

function detectReferral(): string {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref') || params.get('utm_source');
    if (ref) return ref.slice(0, 200);
    const r = document.referrer || '';
    if (!r) return 'direct';
    const host = new URL(r).hostname.replace('www.', '');
    if (host.includes(window.location.hostname)) return 'direct';
    if (/google\./.test(host)) return 'google';
    if (/facebook\.|fb\.|meta\./.test(host)) return 'meta';
    if (/instagram\./.test(host)) return 'instagram';
    if (/t\.co|twitter\.|x\.com/.test(host)) return 'twitter';
    if (/tiktok\./.test(host)) return 'tiktok';
    if (/youtube\.|youtu\.be/.test(host)) return 'youtube';
    return host;
  } catch {
    return 'direct';
  }
}

export async function registerRequest(payload: RegisterPayload): Promise<RegisterResult> {
  const body = { ...payload, referral_source: payload.referral_source || detectReferral() };
  const { data } = await api.post<RegisterResult>('/auth/register', body);
  return data;
}

export async function verifyEmail(token: string): Promise<{ success: boolean; message: string }> {
  const { data } = await api.post('/auth/verify-email', { token });
  return data;
}

export async function resendVerification(email: string): Promise<{ success: boolean; message: string }> {
  const { data } = await api.post('/auth/resend-verification', { email });
  return data;
}

export async function loginRequest(email: string, password: string): Promise<AuthResponse> {
  const { data } = await api.post<AuthResponse>('/auth/login', { email, password });
  return data;
}

export async function meRequest(): Promise<User> {
  const { data } = await api.get<User>('/auth/me');
  return data;
}

export async function forgotPassword(email: string): Promise<{ success: boolean; message: string }> {
  const { data } = await api.post('/auth/forgot-password', { email });
  return data;
}

export async function resetPassword(token: string, new_password: string): Promise<{ success: boolean; message: string }> {
  const { data } = await api.post('/auth/reset-password', { token, new_password });
  return data;
}
